import OnlineTransactions from '@/views/Admin/OnlineTransactions/OnlineTransactions.vue';
import { Route } from '../route.model';

const adminOnlineTransactions = new Route(
  '/admin/online-transactions',
  'admin_online_transactions_list',
  OnlineTransactions,
  {
    isResponsive: true,
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Integration Transactions',
      icon: 'credit-card'
    },
    zendesk: {
      disabled: true
    }
  }
);

export { adminOnlineTransactions };
export default adminOnlineTransactions;
